export default "__VITE_ASSET__y36X2xOT__"